import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { DialogService } from 'src/app/services/dialog.service';
import { HTTPService } from 'src/app/services/http.service';
import { UserAuthenticationServices } from 'src/app/services/user-authentication.services';
import { ObjectUtil } from 'src/app/system-utils/utils/ObjectUtil';
import { MeliTaskProcessorComponent } from './meli-task-processor/meli-task-processor.component';
import { ThemeService } from 'src/app/services/theme.service';

/*
 * Módulos NG-ZORRO necessários no módulo que declara este componente:
 *   NzSelectModule, NzInputModule, NzButtonModule, NzIconModule,
 *   NzSwitchModule, NzRadioModule, NzDividerModule, NzToolTipModule
 * (FormsModule + ReactiveFormsModule já eram necessários antes.)
 */

@Component({
    selector: 'app-meli-mlb-download',
    templateUrl: './meli-mlb-download.component.html',
    styleUrls: ['./meli-mlb-download.component.scss'],
    standalone: false
})
export class MeliMlbDownloadComponent implements OnInit, OnDestroy {

  formInicial: UntypedFormGroup;
  private modelChanged: Subject<string> = new Subject<string>();
  private subscription: Subscription;
  debounceTime = 1000;
  public change: Subject<boolean> = new Subject();
  paging: Object = {};
  meliItens: Object[] = [];
  meliTempItens: Object[] = [];
  mktpmeli: Object[] = [];
  offset = 0;
  codecompany;
  importados = false;
  enableSearch = false;
  findById: boolean = false;
  updateMode: boolean = false;
  listOfCompanies: { codecompany: string; companyname: string; codecontract?: string; contractname?: string; }[] = [{ codecompany: "0", companyname: "sem" }];
  hasMore: boolean = true;
  cancelPaginator: boolean = false;
  sub1: Subscription;
  loading: boolean = false;
  findtitle: FormControl = new FormControl<string>('');
  findmlb: FormControl = new FormControl<string>('');

  // nz-radio-group: valor escalar (0 = todos), não mais array do MatSelectionList
  withVariation: number = 0;
  withRelation: number = 0;
  listTipVariacoes = [
    { key: 0, value: 'melidownload.todos' },
    { key: 1, value: 'melidownload.comvariacao' },
    { key: 2, value: 'melidownload.semvariacao' }
  ];
  listWithRelation = [
    { key: 0, value: 'melidownload.todosrelation' },
    { key: 1, value: 'melidownload.withrelation' },
    { key: 2, value: 'melidownload.withoutrelation' }
  ];

  constructor(private formBuilder: UntypedFormBuilder,
              private http: HTTPService,
              public uid: UserAuthenticationServices,
              private cd: ChangeDetectorRef,
              private spinner: NgxSpinnerService,
              public ThemeService: ThemeService,
              private dialogServices: DialogService) {

    this.formInicial = this.formBuilder.group({
      productSearch: new UntypedFormControl(),
    });
  }

  cancelLoading() {
    this.sub1.unsubscribe();
    this.http.stopSubscription();
    this.loading = false;
    this.cancelPaginator = true;
  }

  ngOnDestroy() {
    if (this.sub1 != null) { this.sub1.unsubscribe(); }
    if (this.subscription != null) { this.subscription.unsubscribe(); }
  }

  inputChanged() {
    if (!this.updateMode) {
      this.modelChanged.next("alterado");
    }
  }

  clearFilters() {
    this.offset = 0;
    this.meliItens = [];
    this.meliTempItens = [];
    this.paging['total'] = 0;
  }

  addItens(data: Object[]) {
    if (ObjectUtil.isNotEmpty(data)) {

      data.forEach((item: Object) => {

        if (this.findById) {
          let newItem = item['body'];

          if (this.meliItens.findIndex(m => m['id'] == newItem['id']) == -1) {
            let id = newItem['id'];

            this.mktpmeli.forEach((value: Object) => {
              if (value['MLB_ANUNCIO'] == id) {
                newItem['hasproduct'] = true;
                newItem['CODEMELI'] = value['CODEMELI'];
                newItem['CODEPRODUCT'] = value['CODEPRODUCT'];
                newItem['CODECOMPANY'] = value['CODECOMPANY'];
                newItem['CODECONTRACT'] = value['CODECONTRACT'];
                newItem['VARIACAO'] = value['VARIACAO'] as string;
              }
            });

            this.meliItens.push(newItem);
            this.meliTempItens.push(newItem);
          } else {
            console.log('está duplicado na listagem:' + newItem['id']);
          }

        } else {
          if (this.meliItens.findIndex(d => d['MLB_ANUNCIO'] == item) == -1) {
            let id = item;

            this.mktpmeli.forEach((value: Object) => {
              if (value['MLB_ANUNCIO'] == id) {
                item['hasproduct'] = true;
                item['CODEMELI'] = value['CODEMELI'];
                item['CODEPRODUCT'] = value['CODEPRODUCT'];
                item['CODECOMPANY'] = value['CODECOMPANY'];
                item['CODECONTRACT'] = value['CODECONTRACT'];
                item['VARIACAO'] = value['VARIACAO'] as string;
              }
            });

            this.meliItens.push(item);
            this.meliTempItens.push(item);
          }
        }
      });

    } else {
      this.hasMore = false;
    }
  }

  selectProduct(data) {
  }

  load(method: string, serviceName: string, params: Object[]) {

    return new Promise((resolve, reject) => {
      let ob = {
        codeCompany: this.codecompany,
        method: method,
        serviceName: serviceName,
      };

      if (params.length > 0) {
        ob['params'] = params;
      }

      let local = {
        entityName: 'Mktpmeli',
        sql: `SELECT            A.MLB_ANUNCIO, 
        A.TITLE, 
        A.CODECOMPANY,
        A.CODECONTRACT,
        A.CODEPRODUCT,
        A.CODEMELI,
        B.NAME AS 'FK_MKTPMELI_MKTPPRODUCTS->NAME',
        A.STATUS,
        DBO.MELI_GETVARIACAO(A.CODECONTRACT,A.CODECOMPANY,A.CODEPRODUCT,A.CODEMELI) AS VARIACAO
      FROM MKTPMELI A INNER JOIN MKTPPRODUCTS B ON A.CODEPRODUCT=B.CODEPRODUCT AND A.CODECONTRACT=B.CODECONTRACT
                
      WHERE A.CODECOMPANY IN (${this.codecompany})`
      };

      this.http.post(local, 'JsonBrokerServices/findnative', false, true, true).subscribe(result => {

        this.mktpmeli = result['SQL'];

        this.sub1 = this.http.post(ob, 'MeliNotifications/getGenericMeli', false, true, false).subscribe(async data => {

          if (this.findById) {
            this.addItens(data['resultado']);
          } else {
            let paging = data['resultado']['paging'];
            this.hasMore = false;

            if (paging) {
              this.paging['total'] = paging.total;
              if (paging.total > paging.offset && paging.total > 100) {
                this.hasMore = true;
              }
            }
            if (data['resultado']['results']) {
              await this.getInfoAdicional(data['resultado']['results']);
            }
          }
          this.cd.markForCheck();
          resolve(true);
        },
        (error) => {
          throw error;
        });
      });

    });
  }

  async getInfoAdicional(result: string[]) {

    let mapa: Map<number, string> = this.getMapOfMlb(result);

    for (const [key, value] of mapa) {

      let params: Object[] = [];

      let ob = {
        key: '?ids',
        value: `${value}`
      };

      params.push(ob);

      this.findById = true;
      await this.load("GET", "FindProdByIds", params).then(d => {
        this.findById = false;
      });
    }
  }

  getMapOfMlb(result: string[]): Map<number, string> {

    const mapa: Map<number, string> = new Map();
    let grupo: string[] = [];
    let index = 0;

    for (let i = 0; i < result.length; i++) {
      grupo.push(result[i]);

      if (grupo.length === 20 || i === result.length - 1) {
        mapa.set(index, grupo.join(","));
        grupo = [];
        index++;
      }
    }

    return mapa;
  }

  enableFilters() {
    this.enableSearch = true;
    this.formInicial.get("productSearch").enable();
  }

  ngOnInit(): void {

    this.formInicial.get("productSearch").disable();
    this.paging['total'] = 0;
    this.listOfCompanies = this.uid.user.companylist;
    this.subscription = this.modelChanged
      .pipe(
        debounceTime(this.debounceTime),
      )
      .subscribe(() => {
        this.clearFilters();
      });

    if (this.uid.user.companylist.length == 1) {
      this.codecompany = this.uid.user.codecompany;
      this.load("GET", "FindProd2", []);
      this.enableSearch = true;
      this.formInicial.get("productSearch").enable();
    }
  }

  loadTotalData(params: Object[] = []) {

    return new Promise(async (resolve, reject) => {
      this.hasMore = true;
      this.cancelPaginator = false;
      this.loading = true;
      this.findById = false;

      let textToFind: string = this.formInicial.get('productSearch').value;

      let obLimit = {
        key: "?limit",
        value: 100
      };

      params.push(obLimit);

      if (ObjectUtil.isNotEmpty(textToFind)) {

        textToFind = textToFind.toUpperCase();
        if (textToFind.toUpperCase().startsWith("MLB")) {
          let ob = {
            key: '&ids',
            value: `encodeString(${textToFind})`
          };

          params.push(ob);
          this.findById = true;
          this.hasMore = false;
          await this.load("GET", "FindProdByIds", params).then(d => resolve(true));

        } else {
          let ob = {
            key: '&q',
            value: `encodeString(${this.formInicial.get('productSearch').value})`
          };
          params.push(ob);
          this.findById = false;
          this.hasMore = false;
          await this.load("GET", "FindProd2", params).then(d => resolve(true));
        }

      } else {
        await this.load("GET", "FindProd2", params).then(d => resolve(true));
        this.enableSearch = true;
        this.formInicial.get("productSearch").enable();
      }
    });
  }

  async pesquisar(p: boolean) {

    if (!this.updateMode) {

      this.meliItens = [];
      this.meliTempItens = [];

      let params: Object[] = [];
      await this.loadTotalData(params).then(async d => {
        while (this.hasMore && !this.cancelPaginator) {
          await this.executeOffSet(params);
        }
        this.loading = false;
      });

    } else {

      if (!p) {
        this.meliItens = [];
        this.meliTempItens = [];
        this.mktpmeli = [];
      }

      this.spinner.show('melidownload');
      let local = {
        entityName: 'Mktpmeli',
        showImageData: false,
        showImagaDataBase64: false,
        showPresentation: true,
        showRelationshipData: false,
        showRelationship: false,
        fetchSize: this.meliItens.length,
        rows: 1000
      };

      if (!this.importados) {
        local['condition'] = "this.STATUS IS NULL AND this.MLB_ANUNCIO IS NOT NULL AND this.CODECOMPANY=" + this.codecompany;
      } else {
        local['condition'] = "this.STATUS IS NOT NULL AND this.MLB_ANUNCIO IS NOT NULL AND this.CODECOMPANY=" + this.codecompany;
      }

      this.http.post(local, 'JsonBrokerServices/find', false, true, true).subscribe(result => {
        this.mktpmeli = result['Mktpmeli'];
        this.paging['total'] = result['totalLines'];
        if (this.mktpmeli.length > 0) {
          for (var m of this.mktpmeli) {
            let ob = {
              ID: m['MLB_ANUNCIO'],
              NAME: m['TITLE'],
              CODEPRODUCT: m['CODEPRODUCT'],
              CODECOMPANY: m['CODECOMPANY'],
              CODECONTRACT: m['CODECONTRACT'],
              CODEMELI: m['CODEMELI'],
              DESCRPROD: m['FK_MKTPMELI_MKTPPRODUCTS->NAME'],
              VARIACAO: m['VARIACAO'],
              checked: m['STATUS'] != null ? false : true,
              imported: m['STATUS'] != null ? true : false
            };
            this.meliItens.push(ob);
            this.meliTempItens.push(ob);
          }
        }
      }, error => {
        this.spinner.hide('melidownload');
        throw error;
      }, () => {
        this.spinner.hide('melidownload');
      });
    }
  }

  executeOffSet(params: object[]) {

    return new Promise(async (resolve, reject) => {
      this.offset = this.offset + 1;

      let index = params.findIndex(p => p['key'] == '&offset');
      if (index == -1) {
        index = params.findIndex(p => p['key'] == '?offset');
      }

      if (index > -1) {
        params.splice(index, 1);
      }

      let key = '';
      if (params.length > 0) {
        key = '&offset';
      } else {
        key = '?offset';
      }

      let ob = {
        key: key,
        value: this.offset * 100
      };

      params.push(ob);

      this.findById = false;

      await this.load("GET", "FindProd2", params).then(d => resolve(true));
    });
  }

  /** nz-switch entrega boolean direto (antes: MatSlideToggleChange.checked) */
  changeMode(checked: boolean) {
    this.updateMode = checked;
    this.meliItens = [];
    this.meliTempItens = [];
    this.paging['total'] = 0;
  }

  acaoAlterar(valor) {
    this.meliItens.forEach(d => {
      d['checked'] = valor;
    });

    this.meliTempItens.forEach(d => {
      d['checked'] = valor;
    });
  }

  processar() {
    let filtered = this.meliItens.filter(d => { return d['checked'] == true; });
    if (filtered.length > 0)
      this.dialogServices.openGenericDialog(MeliTaskProcessorComponent, filtered, (data) => {
      }, () => { }, "400", null, true);
  }

  selectChk(event, item) {
  }

  updateFilter(event) {

    if (this.updateMode) {
      const filterValue = (event.target as HTMLInputElement).value;

      this.meliTempItens = this.meliItens.filter((data: Object[]) => {
        let field: boolean = false;
        field = data['DESCRPROD'].toString().toLowerCase().indexOf(filterValue.toLocaleLowerCase()) !== -1
          || data['ID'].toString().toLowerCase().indexOf(filterValue.toLocaleLowerCase()) !== -1
          || data['CODEPRODUCT'].toString().toLowerCase().indexOf(filterValue.toLocaleLowerCase()) !== -1;

        return field;
      });
    }
  }

  updateFilterGeneric() {

    this.meliTempItens = this.meliItens.filter((data: Object[]) => {
      let findmlbtext = this.findmlb.value;
      let findtitletext = this.findtitle.value;

      let hasMlb = true;
      if (ObjectUtil.isNotEmpty(findmlbtext)) {
        hasMlb = data['id'].toString().toLowerCase().indexOf(findmlbtext.toLowerCase()) !== -1;
      }

      let hasTitle = true;
      if (ObjectUtil.isNotEmpty(findtitletext)) {
        hasTitle = data['title'].toString().toLowerCase().indexOf(findtitletext.toLowerCase()) !== -1;
      }

      // withVariation/withRelation agora são escalares (nz-radio-group)
      let variation = true;
      if (this.withVariation == 1) {
        variation = (data['variations_data'] != null && data['variations_data'].length > 0)
          || (data['variations'] != null && data['variations'].length > 0);
      } else if (this.withVariation == 2) {
        variation = (data['variations_data'] == null && data['variations'] == null)
          || (data['variations'] != null && data['variations'].length == 0)
          || (data['variations_data'] != null && data['variations_data'].length == 0);
      }

      // FIX: o original testava this.withVariation aqui (bug)
      let relation = true;
      if (this.withRelation == 1) {
        relation = (data['CODPROD'] != null);
      } else if (this.withRelation == 2) {
        relation = (data['CODPROD'] == null);
      }

      return variation && hasTitle && hasMlb && relation;
    });
  }
}